/*!
 * divein-gallery-fix.js  —— 产品页「主图 + 缩略图条」交互修复
 *
 * 【定位说明（2026-10-21 更新，很重要）】
 *   「右箭头点不动」的真凶是**层叠上下文被封住**，已由 CSS 修掉
 *   （见 divein-gallery-zfix.css：.details-thumb 抬到 z-index:120）。
 *   那是 CSS 层的事，本脚本不是它的替代品，两者要一起上。
 *
 *【功能总览（2026-06 更新）】
 *   1) 主图自动轮播（小图条 autoplay + 主图跟随，鼠标悬停暂停，3.5 秒/张）
 *   2) animating 卡死看门狗（主题 initADA 报错会打断 slick 的复位链）
 *   3) 主图跟随缩略图，消除「点一下主图跳 2 格」
 *   4) 箭头出视口时拉回（笔记本 1366/1440 下左箭头会有一半在屏外）
 *   5) 图数 <= 显示数时隐藏箭头，避免死按钮
 *
 *【关于自动轮播挂在哪（别改错）】
 *   主题 jquery.product.js 里主图（data-slide-main）的 autoplay 本来就是 false，
 *   主题设计是「小图条 autoplay:true 自动走 → 主图靠 syncMain 跟随」。
 *   所以自动轮播必须挂在小图条上（CFG.autoPlay 控制的就是它）。
 *   ★ 不要给主图单独挂轮播 —— 会导致两边各走各的、点小图或点箭头时不同步。
 *
 *【可调参数（都在 CFG 里）】
 *   autoPlay: false        → 想彻底关掉自动轮播改这里
 *   autoPlaySpeed: 3500    → 每张停留毫秒数，嫌快改大
 *   autoPlayHoverPause:    → 悬停暂停已实现（同时监听小图条 + 主图容器）
 *
 *【历史：曾把自动轮播关掉】
 *   2026-05 肥总反馈「小图自己乱跑」，当时把 autoplay 压成 false。
 *   2026-06 肥总又要求「主图要自动转」→ 改成挂在小图条上 + 悬停暂停。
 *   判据：现在只要 autoplay 开着且不悬停，小图条就应该每 3.5 秒前进一格。
 *
 * 【历史真凶（已由 CSS 修掉，此处仅存档）】
 *   slick 的 animating 标志会卡死在 true：slick 开始滑动时置true，靠
 *   transitionend / setTimeout 复位；本主题里这个复位经常不执行
 *   （每次加载必抛 initADA 的"Cannot read properties of null (reading 'add')"，
 *   会打断回调链），一旦卡死 slick 会忽略所有点击。
 *   ⚠ 所有 slick 实例都在使用时实时获取，不缓存 —— 主题可能在运行中重建轮播，
 *     缓存旧实例会导致操作落到"废对象"上。
 *
 * 安装：Assets 新建本文件；theme.liquid 的 </body> 前加
 *   {{ 'divein-gallery-fix.js' | asset_url | script_tag }}
 * 回滚：删掉那一行即可，不改任何主题核心文件。
 */
(function () {
  'use strict';

  var CFG = {
    autoPlay: true,               // ★ 主图自动轮播总开关（2026-10-21 按肥总要求开回）
    autoPlaySpeed: 3500,          //   每张停留 3500ms
    autoPlayHoverPause: true,     //   鼠标悬停在小图条/主图上时暂停，移开继续
    stopAutoOnLoad: false,        //   旧的「强制关闭」开关，已由 autoPlay 取代
    unlockBeforeStep: true,       // 每次走位前强制解锁 animating（核心）
    queueStepGap: 220,            // 队列两格间隔(ms)
    queueMax: 8,                  // 队列上限
    watchdogMs: 1200,             // animating 超过这么久判卡死
    keepArrowsInViewport: true,   // 箭头出视口时拉回
    syncMainWithNav: true,        // 主图跟随缩略图
    hideWhenNotScrollable: true,  // 无可滚空间时藏箭头
    removeThemeArrowHack: true    // 摘掉主题「点箭头→强制点当前小图」的 hack
  };

  var $sel = function (s, r) { return (r || document).querySelector(s); };
  var navEl = null;

  function inst() {                       // 实时取当前 slick 实例，绝不缓存
    if (!navEl || !window.jQuery) return null;
    try { return window.jQuery(navEl).slick('getSlick'); } catch (e) { return null; }
  }
  function smInst() {
    var m = document.querySelector('div[data-slide-main]');
    if (!m || !window.jQuery) return null;
    try { return window.jQuery(m).slick('getSlick'); } catch (e) { return null; }
  }
  function unlock() {
    var s = inst();
    if (s && s.animating) s.animating = false;
  }

  /* ---------- 主图跟随缩略图 ---------- */
  var syncing = false, syncTries = 0;
  function syncMain() {
    if (!CFG.syncMainWithNav) return;
    var s = inst(), m = smInst(), mEl = document.querySelector('div[data-slide-main]');
    if (!s || !m || !mEl || !m.slideCount) return;
    var target = ((s.currentSlide % m.slideCount) + m.slideCount) % m.slideCount;
    if (m.currentSlide === target) { syncing = false; return; }
    if (syncing) return;
    syncing = true; syncTries++;
    try { m.animating = false; window.jQuery(mEl).slick('slickGoTo', target); } catch (e) {}
    setTimeout(function () {
      var m2 = smInst();
      if (m2 && m2.currentSlide !== target && syncTries < 4) setTimeout(syncMain, 260);  // 没跟上就再试
      else { syncing = false; if (syncTries >= 4) syncTries = 0; }
    }, 280);
  }

  /* ---------- 强制走位 ---------- */
  function step(dir) {
    if (CFG.unlockBeforeStep) unlock();
    var s = inst();
    if (!s) return;
    var before = s.currentSlide;
    try { window.jQuery(navEl).slick(dir === 'next' ? 'slickNext' : 'slickPrev'); } catch (e) {}
    setTimeout(function () {
      var s2 = inst();
      if (!s2 || s2.currentSlide !== before) return;
      if (CFG.unlockBeforeStep) s2.animating = false;
      var n = s2.slideCount;
      var to = dir === 'next' ? (before + 1) % n : (before - 1 + n) % n;
      try { window.jQuery(navEl).slick('slickGoTo', to); } catch (e) {}
    }, 140);
  }

  /* ---------- 队列（固定间隔，不依赖 animating） ---------- */
  var queue = [], running = false;
  function pump() {
    if (running) return;
    running = true;
    (function next() {
      if (queue.length) { step(queue.shift()); setTimeout(next, CFG.queueStepGap); }
      else {
        running = false;
        [350, 900, 1800, 3000].forEach(function (t) { setTimeout(syncMain, t); });
      }
    })();
  }
  function enqueue(dir) {
    if (queue.length < CFG.queueMax) queue.push(dir);
    pump();
  }

  /* ---------- 箭头位置：基于「相对容器的自然偏移」稳定计算 ----------
   *
   * 【2026-10-21 改动：transform 必须带上 translateY(-50%)】
   *   之前这里写的是 a.style.transform = 'translateX(Npx)'，会把主题
   *   slick 的 transform: translate(0px, -50%) 整个冲掉。
   *   箭头只有 40px 高时，丢掉的那半个高度（-20px）看不出来；
   *   现在箭头改成跟小图一样高（约 128px）后，1366/1440 视口下
   *   （那里需要拉回视口，transform 才会被写）会整体下移 64px，明显歪。
   *   所以：水平拉回 + 垂直居中 两件事必须同时写进同一个 transform。
   */
  function fixPos() {
    if (!CFG.keepArrowsInViewport || !navEl) return;
    var vw = window.innerWidth || document.documentElement.clientWidth, pad = 8;
    var navR = navEl.getBoundingClientRect();
    if (!navR.width) return;
    ['.slick-prev', '.slick-next'].forEach(function (c) {
      var a = $sel(c, navEl);
      if (!a || a.style.display === 'none') return;
      var r = a.getBoundingClientRect();
      if (!r.width) return;
      /* 用 offsetLeft 实时取「相对容器的自然偏移」，不缓存。
       * offsetLeft 是布局值，不受自身 transform 影响；CSS 里改 left/right 会立刻反映。
       * ★ 旧写法是「第一次量出 __dvOff 就永久缓存」—— 一旦你在 CSS 里
       *   改了箭头的 left 位置，这个缓存就过期了，拉回视口的量会算错，
       *   箭头可能被推出屏幕外点不到。2026-10-21 改为实时计算。 */
      var off = (typeof a.offsetLeft === 'number') ? a.offsetLeft : (r.x - navR.x);
      var natX = navR.x + off;               // 自然位置（绝对坐标）
      var dx = 0;
      if (natX < pad) dx = pad - natX;
      if (natX + r.width > vw - pad) dx = (vw - pad) - (natX + r.width);
      // translateY(-50%) = 主题 slick 用来做垂直居中的那一半，必须保留
      a.style.transform = 'translateX(' + Math.round(dx) + 'px) translateY(-50%)';
      a.style.zIndex = '9999';
      a.style.pointerEvents = 'auto';
    });
  }

  /* ---------- 主流程 ---------- */
  function boot() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    navEl = document.querySelector('div[data-slide-nav]');
    if (!navEl) return;
    if (!navEl.classList.contains('slick-initialized')) { setTimeout(boot, 400); return; }

    var J = window.jQuery;
    if (!J || !J.fn || !J.fn.slick) { setTimeout(boot, 400); return; }
    var s = inst();
    if (!s || !s.slideCount) { setTimeout(boot, 400); return; }

    /* 1) 自动轮播（2026-06 起按肥总要求开回，悬停暂停）
     *
     *   【为什么挂在小图条上而不是主图上】
     *   主题 jquery.product.js 里，主图（data-slide-main）的 autoplay 本来就是
     *   false，主题设计是「小图条 autoplay:true 自动走 → 主图靠 syncMain 跟随」。
     *   所以自动轮播必须挂在小图条上（CFG.autoPlay 控制的就是它）。
     *   ★ 不要给主图单独挂轮播 —— 会导致两边各走各的、点小图或点箭头时不同步。
     *
     *   【关键：为什么不用 slick 自带 autoplay，而是自己 setInterval 调 slickNext】
     *   主题的 jquery.product.js 里有：
     *     setTimeout(function(){ slideNav.slick('slickPlay'); }, 5000);   // 兜底启动
     *   这行会在 5 秒后不管三七二十一把 autoplay 开回来。
     *   如果跟它抢（谁后执行谁赢），会出现「speed 被来回改写」的拉锯：
     *   实测设 2500/2000 都会被拉回 3000/3500，且真实间隔 = 配置值 + 约1.4 秒
     *   （slick 的 pauseOnHover/interrupt 与主题的 slickPause 互相打断所致）。
     *
     *   所以本脚本的做法是：**把 slick 的原生 autoplay 彻底关掉**（让它永远处于
     *   paused，主题那行 slickPlay 也救不回来），然后自己用 setInterval 按
     *   CFG.autoPlaySpeed 的节奏调 slickNext。间隔 = 你写多少就是多少，精确可控。
     */
    var hoverList = [];
    function hoverArea() {
      var out = [];
      var d = $sel('.details-thumb');
      if (d) out.push(d);
      var t = $sel('.cms-wrap-main-slider .main-image');
      if (t) out.push(t);
      return out;
    }

    /* 始终把 slick 原生 autoplay 关死，让自动轮播只由我们的定时器驱动 */
    function killNative() {
      var k = inst(); if (!k) return;
      if (k.options.autoplay) {
        k.options.autoplay = false;
        try { J(navEl).slick('slickPause'); } catch (e) {}
        clearInterval(k.autoPlayTimer);
        k.autoPlayTimer = undefined;
      }
    }

    var ticking = false;
    function autoStep() {
      if (!CFG.autoPlay || !navEl.__dvAutoRun) return;
      if (ticking) return;                    // 上一格还在滑就跳过，别叠
      var k = inst(); if (!k || !k.slideCount) return;
      if (k.slideCount <= k.options.slidesToShow) return;   // 没得翻就不翻
      if (!k.options.infinite && k.currentSlide >= k.slideCount - 1) return;
      ticking = true;
      try {
        unlock();
        J(navEl).slick('slickNext');
      } catch (e) {}
      setTimeout(function () { ticking = false; }, Math.max(600, CFG.autoPlaySpeed - 1800));
    }

    function startAuto() {
      if (!CFG.autoPlay || navEl.__dvAutoTimer) return;
      navEl.__dvAutoRun = true;
      navEl.__dvAutoTimer = setInterval(autoStep, CFG.autoPlaySpeed);
    }
    function stopAuto() {
      if (navEl.__dvAutoTimer) { clearInterval(navEl.__dvAutoTimer); navEl.__dvAutoTimer = null; }
    }
    function refreshAuto() {                 // 悬停状态变化后统一收口
      killNative();
      var k = inst();
      var hovering = !!(k && k.__dvHovering);
      if (CFG.autoPlay && !hovering) { startAuto(); } else { stopAuto(); }
    }

    if (!navEl.__dvAutoLoop) {
      navEl.__dvAutoLoop = setInterval(killNative, 300);  // 持续压住主题的复活
      hoverArea().forEach(function (elm, i) {
        var mark = '__dvHoverBind' + i;
        if (elm[mark]) return;
        elm[mark] = true;
        elm.addEventListener('mouseenter', function () {
          var k = inst(); if (k) k.__dvHovering = true;
          refreshAuto();
        });
        elm.addEventListener('mouseleave', function () {
          var k = inst(); if (k) k.__dvHovering = false;
          refreshAuto();
        });
      });
      window.addEventListener('blur', function () {
        var k = inst(); if (k) k.__dvHovering = true;
        refreshAuto();
      });
      window.addEventListener('focus', function () {
        var k = inst(); if (k) k.__dvHovering = false;
        refreshAuto();
      });
    }
    refreshAuto();

    /* 客户主动操作后重置计时：slick 的 autoPlayIterator 是 setInterval，
       点完箭头后如果不清掉，客户刚看完这一张就被自动切走，体验很突兀。
       这里重建定时器，从头开始数 3.5 秒。 */
    function restartAuto() {
      if (!CFG.autoPlay) return;
      var k = inst(); if (!k || k.__dvHovering) return;
      stopAuto();
      setTimeout(startAuto, 900);   // 等滑动动画走完再恢复，避免中途被切
    }

    /* 3) animating 看门狗 */
    if (!window.__dvWd) {
      window.__dvWd = setInterval(function () {
        var k = inst(); if (!k) return;
        if (!k.animating) { k.__dvStuck = 0; return; }
        if (!k.__dvStuck) { k.__dvStuck = Date.now(); return; }
        if (Date.now() - k.__dvStuck > CFG.watchdogMs) {
          k.animating = false; k.__dvStuck = 0;
          try { k.setPosition && k.setPosition(); } catch (e) {}
        }
      }, 150);
    }

    /* 2) 箭头点击接管（只挂一次，靠 __dvFix 标记） */
    ['.slick-prev', '.slick-next'].forEach(function (sel) {
      var el = $sel(sel, navEl);
      if (!el || el.__dvFix) return;
      el.__dvFix = true;
      var dir = sel === '.slick-next' ? 'next' : 'prev';
      el.addEventListener('click', function () {
        var k = inst(); if (!k) return;
        var before = k.currentSlide;
        setTimeout(function () {
          var k2 = inst();
          if (k2 && k2.currentSlide === before) enqueue(dir);   // slick 没响应 → 补
        }, 0);
        // 客户主动操作 → 重新开始计时，别在刚点完就立刻被自动切走
        restartAuto();
      }, true);
    });

    /* 4) 点小图先解锁 + 重置计时 */
    if (!navEl.__dvThumb) {
      navEl.__dvThumb = true;
      navEl.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.slick-arrow')) return;
        unlock();
        restartAuto();
      }, true);
    }

    /* 6) 主图跟随 */
    J(navEl).on('afterChange', syncMain);
    setTimeout(syncMain, 60);
    setTimeout(syncMain, 1800);

    /* 7) 无可滚空间 → 藏箭头 */
    if (CFG.hideWhenNotScrollable && s.slideCount <= s.options.slidesToShow) {
      ['.slick-prev', '.slick-next'].forEach(function (x) { var a = $sel(x, navEl); if (a) a.style.display = 'none'; });
    }

    /* 摘掉主题 hack */
    if (CFG.removeThemeArrowHack) {
      try { J(document).off('click', 'div[data-slide-nav] .slick-arrow'); } catch (e) {}
    }

    /* 5) 位置持续重算：布局常在懒加载后才稳定 */
    fixPos();
    [400, 1200, 2500, 4000, 6000].forEach(function (t) { setTimeout(fixPos, t); });
  }

  window.addEventListener('resize', fixPos);
  window.addEventListener('scroll', function () { if (CFG.keepArrowsInViewport) fixPos(); }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 300); });
  } else { setTimeout(boot, 300); }
  window.addEventListener('load', function () { [800, 2000, 3500, 6000].forEach(function (t) { setTimeout(boot, t); }); });
})();